// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"816df44d","342":"c6e95613","639":"ddfa6ab9","704":"c4268e57","864":"665a18cd"}[chunkId] + ".chunk.js";
};